import { tns } from 'tiny-slider';

document.addEventListener(
	'DOMContentLoaded',
	function () {
		const heroHome = document.querySelector('.hero-home');
		const navButtons = heroHome.querySelectorAll('.custom-nav .nav-button');
		const indicator = heroHome.querySelector('.nav-indicator');
		let currentIndex = 0;

		const sliderImages = tns({
			container: '.hero-home__images',
			items: 1,
			slideBy: 'page',
			nav: false,
			controls: false,
			loop: true,
			startIndex: 0,
			touch: false,
			mouseDrag: false,
			mode: 'gallery',
			navContainer: '.custom-nav',
			autoplay: false,
			autoplayButtonOutput: false,
			responsive: {
				768: { items: 1 },
				1024: {
					items: 1,
					nav: true,
					navPosition: 'bottom',
					controlsPosition: 'bottom',
					navAsThumbnails: true,
					mouseDrag: true,
					touch: true,
					autoplay: true,
				},
			},
		});

		const sliderCards = tns({
			container: '.carousel-content',
			items: 1,
			slideBy: 'page',
			controls: false,
			nav: true,
			navPosition: 'bottom',
			hasFixedWidth: true,
			fixedWidth: 280,
			center: true,
			loop: true,
			startIndex: 0,
			autoplay: true,
			autoplayButtonOutput: false,
			responsive: {
				768: {
					navAsThumbnails: true,
					fixedWidth: 580,
				},
				1024: {
					nav: false,
					items: 3,
					fixedWidth: false,
					center: false,
					mouseDrag: false,
					touch: false,
					loop: false,
					autoplay: false,
				},
			},
		});

		//Synca cards com imagens
		sliderCards.events.on('indexChanged', syncImageSlider);
		sliderImages.events.on('indexChanged', syncCardSlider);

		//Muda a posição e estilo do indicador de navegação
		sliderImages.events.on('indexChanged', function (info) {
			updateIndicatorPosition(info.displayIndex - 1);
			updateIndicatorStyle(info.displayIndex - 1);
		});

		const carouselCards = document.querySelectorAll('.carousel-content .card');

		carouselCards.forEach((card) => {
			card.addEventListener('mouseover', function () {
				// Pausa o autoplay dos sliders
				sliderImages.pause();
				sliderCards.pause();
				const cardId = card.dataset.id;
				syncSliderToCard(cardId);
			});

			card.addEventListener('mouseout', function () {
				// Reinicia o autoplay dos sliders
				sliderImages.play();
				sliderCards.play();
			});
		});

		function syncSliderToCard(cardId) {
			const images = document.querySelectorAll('.hero-home__images__image');
			const targetImage = Array.from(images).find((img) => img.dataset.id === cardId);
			const targetIndex = Array.from(images).indexOf(targetImage);

			if (targetIndex !== -1) {
				sliderImages.goTo(targetIndex);
				updateIndicatorPosition(targetIndex);
				updateIndicatorStyle(targetIndex);
			}
		}

		function syncImageSlider(info) {
			const activeCardId = info.slideItems[info.index].dataset.id;
			const images = document.querySelectorAll('.hero-home__images__image');
			const targetImage = Array.from(images).find((img) => img.dataset.id === activeCardId);
			const targetIndex = Array.from(images).indexOf(targetImage);

			sliderImages.goTo(targetIndex);
		}

		function syncCardSlider(info) {
			const cards = document.querySelectorAll('.hero-home.card');
			cards.forEach((card) => card.classList.remove('active'));

			const cardIndex = info.displayIndex;
			if (cards[cardIndex]) {
				cards[cardIndex].classList.add('active');
			}
		}

		function updateIndicatorPosition(index) {
			let activeButton = navButtons[index];
			let leftPosition = activeButton.offsetLeft + activeButton.offsetWidth / 2 - indicator.offsetWidth / 2;
			indicator.style.left = `${leftPosition}px`;
		}

		function updateIndicatorStyle(index) {
			let totalSlides = navButtons.length;
			let indicator = document.querySelector('.nav-indicator');
			if (index === 0) {
				// Primeiro slide
				indicator.style.borderRadius = '0px 20px 20px 0px';
			} else if (index === totalSlides - 1) {
				// Último slide
				indicator.style.borderRadius = '20px 0px 0px 20px';
			} else {
				// Slides intermediários
				indicator.style.borderRadius = '20px';
			}
		}

		// Inicializa a posição do indicador
		updateIndicatorPosition(0);
		updateIndicatorStyle(0);

		//Adiciona a classe active ao primeiro card
		const firstCard = heroHome.querySelector('.carousel-content .card.tns-slide-active');
		if (firstCard) {
			firstCard.classList.add('active');
		}
	},
	false,
);
